// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f20dc38f","703":"5ba42e78","787":"6198c1d5"}[chunkId] + ".chunk.js";
};